const patternNumber = /^\d{1,10}$/;
const initialFormValues = {
  value: '',
  amount: '',
  valid: true,
  additional_agreement: false,
  operator: null,
  bank: null,
  card_date_issue: '',
  card_cvv: '',
  card_cardholder: '',
  card_phone_number: '',
};

export default {
  data() {
    return {
      current: {},
      enabledPayments: [],
      config: {},
      operators: [],
      banks: [],
      settings: [],
      paymentFinish: false,
      isLoad: false,
      message: '',
      form: { ...initialFormValues },
      rules: {
        required: value => !!value || 'Поле должно быть заполнено',
        phoneLength: value => (value.length >= 17) || 'Номер телефона заполнен не полностью',
        cardLength: value => (value.length >= 19) || 'Номер карты заполнен не полностью',
        number: value => patternNumber.test(value) || 'Поле должно содержать только числа',
      },
    };
  },
  computed: {
    user() { return this.$store.state.user; },
    isAuthenticated() { return this.$store.getters.isAuthenticated; },
    paymentsInfo() { return this.$store.state.paymentsInfo; },
    paymentsConfig() { return this.$store.state.paymentsConfig; },
    paymentOperators() { return this.$store.state.paymentOperators; },
    paymentBanks() { return this.$store.state.paymentBanks; },
    hasTaxes() { return this.$store.state.settings.taxes === true; },
    selectedType() { return this.$store.state.payments.repeatType || null; },
    selectedData() { return this.$store.state.payments.repeatData || null; },
    selectedValue() { return this.$store.state.payments.repeatValue || null; },
    isRus() { return this.$store.getters.isRus; },
    isBy() { return this.$store.getters.isBy; },
    isKz() { return this.$store.getters.isKz; },
    userHasPassport() {
      return this.user && this.user.account && this.user.account.status === 'approved';
    },
    showCurrency() {
      if (!this.isRus) {
        return this.isBy ? 'BYN' : 'KZT';
      }
      return '';
    },
  },
  methods: {
    GetPaymentMessage(e) {
      const app = this;
      const amount = parseInt(e.target.value, 10);
      const { type } = this.current;
      // eslint-disable-next-line camelcase
      const { profile_id } = app.user;
      if (type && amount) {
        this.$store.getters.ax.post('payments/api-v5/payments/calculate', { type, amount, profile_id })
          .then((response) => {
            const { totalAmount, message } = response.data;
            const msg = (amount === totalAmount) ? '' : `Стоимость: ${totalAmount} (${message})`;
            this.$set(this.$data, 'message', msg);
          }).catch(() => {
            this.$set(this.$data, 'message', '');
          });
      }
    },
    setFormValueField() {
      if (this.current.type === 'yandex' || this.current.type === 'webmoney') {
        return {
          rules: [this.rules.required],
          type: 'text',
          mask: null,
        };
      }
      if (this.current.type === 'rbs') {
        return {
          rules: [this.rules.required, this.rules.number],
          type: 'number',
          mask: null,
        };
      }
      if (this.current.type === 'phone' || this.current.type === 'qiwi') {
        return {
          rules: [this.rules.required],
          type: 'text',
          mask: this.config.phone_number_mask,
        };
      }
      if (this.current.type === 'card') {
        return {
          rules: [this.rules.required],
          type: 'text',
          mask: '#### #### #### ######',
        };
      }
      return false;
    },
    handleChangeMethod(item) {
      this.current = item;
      this.$store.dispatch('payments/SetPayment', { clear: true })
        .then(() => this.ResetForm());
    },
    paymentSubmit() {
      const app = this;
      const rate = app.user.currency_rate && app.user.currency_rate.payments_rate
        ? app.user.currency_rate.payments_rate : 0;
      const rateVal = ((rate > 0) ? rate : 1);
      if (app.form.valid) {
        app.isLoad = true;
        const payment = {
          profile_id: app.user.profile_id,
          type: app.current.type,
          amount: Math.round(app.form.amount * rateVal),
          amount_origin: app.form.amount,
          rate: rateVal,
          additional_agreement: app.form.additional_agreement,
          parameters: {
            phone_mobile: app.form.value,
            operator: app.form.operator,
            bank: app.form.bank,
            card_date_issue: app.form.card_date_issue,
            card_cvv: app.form.card_cvv,
            card_cardholder: app.form.card_cardholder,
            card_phone_number: app.form.card_phone_number,
          },
        };
        app.$store.getters.axl.post('payments/api-v5/payments/create', payment)
          .then(() => {
            app.ResetForm();
            this.$store.dispatch('GetProfile');
            app.paymentFinish = true;
          })
          .catch((error) => {
            app.$store.dispatch('HandleError', error);
          })
          .finally(() => {
            app.isLoad = false;
          });
      }
    },
    ResetForm() {
      this.$set(this.$data, 'form', { ...initialFormValues });
    },
    CheckCardholder() {
      this.form.card_cardholder = this.form.card_cardholder
        .toUpperCase()
        .replace(/[^A-Z\s]+/ig, '');
    },
  },
  mounted() {
    const app = this;
    if (app.user && app.user.profile_id) {
      app.$store.dispatch('GetPaymentsSettings', app.user.profile_id)
        .then(() => {
          app.$set(app.$data, 'enabledPayments', app.paymentsInfo);
          app.$set(app.$data, 'config', app.paymentsConfig);
          app.$set(app.$data, 'operators', app.paymentOperators);
          app.$set(app.$data, 'banks', app.paymentBanks);

          if (app.enabledPayments && app.enabledPayments.length) {
            if (app.selectedType && app.selectedData && app.selectedValue) {
              const selectedPayment = app.enabledPayments.find(i => i.type === app.selectedType);
              app.$set(app.$data.current, 'type', selectedPayment.type);
              app.$set(app.$data.form, 'value', app.selectedData);
              app.$set(app.$data.form, 'amount', app.selectedValue);
            } else {
              // eslint-disable-next-line prefer-destructuring
              app.$set(app.$data, 'current', app.enabledPayments[0]);
            }
          } else {
            app.current = {};
          }
        });
    }
  },
  destroyed() {
    this.$store.dispatch('payments/SetPayment', { clear: true });
    this.ResetForm();
  },
};
